import React from 'react';
import PropTypes from 'prop-types';

import AddToCalendarContainer from '../../components/AddToCalendarContainer';

const AddToCalendar = ({ className, getCalendarLink }) => (
  <div className={className}>
    <div className="u-text-medium u-co-gray u-mb-3">Add to calendar</div>
    <div className="u-text-center u-flex">
      <a className="c-calendar-button u-mr-2 dark-invert" href={getCalendarLink('ical')} target="_blank">
        <span data-bg-icon="apple">iCal</span>
      </a>
      <a className="c-calendar-button u-mr-2 dark-invert" href={getCalendarLink('google')} target="_blank">
        <span data-bg-icon="google">Google</span>
      </a>
      <a className="c-calendar-button dark-invert" href={getCalendarLink('yahoo')} target="_blank">
        <span data-bg-icon="yahoo">Yahoo</span>
      </a>
    </div>
  </div>
);

AddToCalendar.propTypes = {
  className: PropTypes.string,
  getCalendarLink: PropTypes.func.isRequired,
};

AddToCalendar.defaultProps = {
  className: '',
};

export default AddToCalendarContainer(AddToCalendar);



// WEBPACK FOOTER //
// ./src/app/notifications/shared/AddToCalendar.jsx